###*
# angular-snapscroll
# Version: 0.2.4
# (c) 2014-2015 Joel Mukuthu
# MIT License
# Built on: 20-05-2015 00:16:02 GMT+0200
#
###

do ->

  easeInOutQuad = (t, b, c, d) ->
    t /= d / 2
    if t < 1
      return c / 2 * t * t + b
    t--
    -c / 2 * (t * (t - 2) - 1) + b

  'use strict'
  angular.module('snapscroll', []).value('defaultSnapscrollScrollEasing', easeInOutQuad).value('defaultSnapscrollScrollDelay', 250).value('defaultSnapscrollSnapDuration', 800).value('defaultSnapscrollResizeDelay', 400).value 'defaultSnapscrollBindScrollTimeout', 400
  return
do ->
  'use strict'
  angular.module('snapscroll').directive 'fitWindowHeight', [
    '$window'
    '$timeout'
    'defaultSnapscrollResizeDelay'
    ($window, $timeout, defaultSnapscrollResizeDelay) ->
      {
        restrict: 'A'
        require: 'snapscroll'
        link: (scope, element, attributes, snapscroll) ->
          windowElement = undefined
          resizePromise = undefined
          resizeDelay = attributes.resizeDelay

          onWindowResize = ->
            if resizeDelay == false
              snapscroll.setSnapHeight $window.innerHeight
            else
              $timeout.cancel resizePromise
              resizePromise = $timeout((->
                snapscroll.setSnapHeight $window.innerHeight
                return
              ), resizeDelay)
            return

          init = ->
            if resizeDelay == 'false'
              resizeDelay = false
            else
              resizeDelay = parseInt(resizeDelay, 10)
              if isNaN(resizeDelay)
                resizeDelay = defaultSnapscrollResizeDelay
            # set initial snapHeight
            snapscroll.setSnapHeight $window.innerHeight
            # update snapHeight on window resize
            windowElement = angular.element($window)
            windowElement.on 'resize', onWindowResize
            scope.$on '$destroy', ->
              windowElement.off 'resize'
              return
            return

          init()
          return

      }
  ]
  return
do ->
  'use strict'
  scopeObject = 
    snapIndex: '=?'
    snapHeight: '=?'
    beforeSnap: '&'
    afterSnap: '&'
    snapAnimation: '=?'
  controller = [
    '$scope'
    ($scope) ->

      @setSnapHeight = (height) ->
        $scope.snapHeight = height
        return

      return
  ]

  isNumber = (value) ->
    angular.isNumber(value) and !isNaN(value)

  watchSnapHeight = (scope, callback) ->
    scope.$watch 'snapHeight', (snapHeight, previousSnapHeight) ->
      if angular.isUndefined(snapHeight)
        scope.snapHeight = scope.defaultSnapHeight
        return
      if !isNumber(snapHeight)
        if isNumber(previousSnapHeight)
          scope.snapHeight = previousSnapHeight
        else
          scope.snapHeight = scope.defaultSnapHeight
        return
      if angular.isFunction(callback)
        callback snapHeight
      return
    return

  watchSnapIndex = (scope, callback) ->
    scope.$watch 'snapIndex', (snapIndex, previousSnapIndex) ->
      if angular.isUndefined(snapIndex)
        scope.snapIndex = 0
        return
      if !isNumber(snapIndex)
        if isNumber(previousSnapIndex)
          scope.snapIndex = previousSnapIndex
        else
          scope.snapIndex = 0
        return
      if snapIndex % 1 != 0
        scope.snapIndex = Math.round(snapIndex)
        return
      if scope.ignoreThisSnapIndexChange
        scope.ignoreThisSnapIndexChange = undefined
        return
      if !scope.isValid(snapIndex)
        scope.ignoreThisSnapIndexChange = true
        scope.snapIndex = previousSnapIndex
        scope.snapDirection = 0
        return
      if scope.beforeSnap(snapIndex: snapIndex) == false
        scope.ignoreThisSnapIndexChange = true
        scope.snapIndex = previousSnapIndex
        return
      if angular.isFunction(callback)
        if snapIndex > previousSnapIndex
          scope.snapDirection = 1
        else if snapIndex < previousSnapIndex
          scope.snapDirection = -1
        callback snapIndex, ->
          scope.snapDirection = 0
          scope.afterSnap snapIndex: snapIndex
          return
      return
    return

  initWheelEvents = (scope, element) ->
    onWheel = undefined
    bindWheel = undefined
    unbindWheel = undefined

    onWheel = (e) ->
      bubbleUp = undefined
      delta = undefined
      if e.originalEvent
        e = e.originalEvent
      e.preventDefault()
      delta = Math.max(-1, Math.min(1, e.wheelDelta or -(e.deltaY or e.detail)))
      if isNaN(delta)
        return
      if delta < 0
        if scope.snapDirection != 1
          if scope.snapIndex + 1 > scope.scopeIndexMax()
            bubbleUp = true
          else
            bubbleUp = false
            scope.$apply ->
              scope.snapIndex += 1
              return
      else
        if scope.snapDirection != -1
          if scope.snapIndex - 1 < scope.snapIndexMin()
            bubbleUp = true
          else
            bubbleUp = false
            scope.$apply ->
              scope.snapIndex -= 1
              return
      if !bubbleUp
        e.stopPropagation()
      return

    bindWheel = ->
      element.on 'wheel mousewheel onmousewheel', onWheel
      return

    unbindWheel = ->
      element.off 'wheel mousewheel onmousewheel', onWheel
      return

    bindWheel()
    scope.$on '$destroy', unbindWheel
    return

  snapscrollAsAnAttribute = [
    '$timeout'
    'scroll'
    'defaultSnapscrollScrollDelay'
    'defaultSnapscrollSnapDuration'
    'defaultSnapscrollBindScrollTimeout'
    ($timeout, scroll, defaultSnapscrollScrollDelay, defaultSnapscrollSnapDuration, defaultSnapscrollBindScrollTimeout) ->
      {
        restrict: 'A'
        controller: controller
        link: (scope, element, attributes) ->
          init = undefined
          snapTo = undefined
          onScroll = undefined
          bindScroll = undefined
          scrollBound = undefined
          unbindScroll = undefined
          scrollPromise = undefined
          bindScrollPromise = undefined
          snapEasing = attributes.snapEasing
          scrollDelay = attributes.scrollDelay
          snapDuration = attributes.snapDuration
          preventSnappingAfterManualScroll = angular.isDefined(attributes.preventSnappingAfterManualScroll)


          scope.setSnapHeight = (height) ->
            scope.snapHeight = height

          snapTo = (index, afterSnap) ->
            args = undefined
            top = index * scope.snapHeight
            if scope.snapAnimation
              if angular.isDefined(snapEasing)
                args = [
                  element
                  top
                  snapDuration
                  snapEasing
                ]
              else
                args = [
                  element
                  top
                  snapDuration
                ]
            else
              args = [
                element
                top
              ]
            
            if !preventSnappingAfterManualScroll and scrollBound
              unbindScroll()
            scroll.to.apply(scroll, args).then ->
              if angular.isFunction(afterSnap)
                afterSnap()
              if !preventSnappingAfterManualScroll
                # bind scroll after a timeout
                $timeout.cancel bindScrollPromise
                bindScrollPromise = $timeout(bindScroll, defaultSnapscrollBindScrollTimeout)
              return
            return

          onScroll = ->

            snap = ->
              top = element[0].scrollTop
              newSnapIndex = Math.round(top / scope.snapHeight)
              if scope.snapIndex == newSnapIndex
                snapTo newSnapIndex
              else
                scope.$apply ->
                  scope.snapIndex = newSnapIndex
                  return
              return

            scroll.stop element
            if scrollDelay == false
              snap()
            else
              $timeout.cancel scrollPromise
              scrollPromise = $timeout(snap, scrollDelay)
            return

          bindScroll = ->
            # if the bindScroll timeout expires while snapping is ongoing, restart the timer
            if scope.snapDirection != 0
              bindScrollPromise = $timeout(bindScroll, defaultSnapscrollBindScrollTimeout)
              return
            element.on 'scroll', onScroll
            scrollBound = true
            return

          unbindScroll = ->
            element.off 'scroll', onScroll
            scrollBound = false
            return

          init = ->
            if scrollDelay == 'false'
              scrollDelay = false
            else
              scrollDelay = parseInt(scrollDelay, 10)
              if isNaN(scrollDelay)
                scrollDelay = defaultSnapscrollScrollDelay
            if angular.isDefined(snapEasing)
              snapEasing = scope.$parent.$eval(snapEasing)
            snapDuration = parseInt(snapDuration, 10)
            if isNaN(snapDuration)
              snapDuration = defaultSnapscrollSnapDuration
            scope.$watch 'snapAnimation', (animation) ->
              if animation == undefined
                scope.snapAnimation = true
              return
            scope.defaultSnapHeight = element[0].offsetHeight

            scope.snapIndexMin = ->
              0

            scope.isValid = (snapIndex) ->
              snapIndex >= scope.snapIndexMin() and snapIndex <= scope.scopeIndexMax()

            element.css 'overflowY', 'auto'
            watchSnapHeight scope, ->
              snaps = element.children()
              element.css 'height', scope.snapHeight + 'px'
              if snaps.length
                angular.forEach snaps, (snap) ->
                  angular.element(snap).css 'height', scope.snapHeight + 'px'
                  return
              snapTo scope.snapIndex
              return
            watchSnapIndex scope, snapTo
            if !preventSnappingAfterManualScroll
              bindScroll()
              scope.$on '$destroy', unbindScroll
              initWheelEvents scope, element
            return

          init()
          return

      }
  ]
  angular.module('snapscroll').directive 'snapscroll', snapscrollAsAnAttribute
  return
do ->
  'use strict'
  # all this is adapted from https://github.com/darius/requestAnimationFrame/blob/master/requestAnimationFrame.js
  # ngAnimate does have $$animateReflow, but that was not built to be a wrapper around requestAnimationFrame, hence this.

  getWithVendorPrefix = (funcName, $window) ->
    vendors = [
      'webkit'
      'moz'
    ]
    func = undefined
    i = 0
    while i < vendors.length and !func
      vp = vendors[i]
      func = $window[vp + funcName]
      ++i
    func

  iOS6 = ($window) ->
    /iP(ad|hone|od).*OS 6/.test $window.navigator.userAgent

  if !Date.now

    Date.now = ->
      (new Date).getTime()

  snapscroll = angular.module('snapscroll')
  snapscroll.factory 'requestAnimation', [
    '$timeout'
    '$window'
    ($timeout, $window) ->
      lastTime = undefined
      requestAnimation = $window.requestAnimationFrame or getWithVendorPrefix('RequestAnimationFrame', $window)
      if !requestAnimation or iOS6($window)
        # iOS6 is buggy

        requestAnimation = (callback) ->
          now = Date.now()
          nextTime = Math.max(lastTime + 16, now)
          $timeout (->
            callback lastTime = nextTime
            return
          ), nextTime - now

      requestAnimation
  ]
  snapscroll.factory 'cancelAnimation', [
    '$timeout'
    '$window'
    ($timeout, $window) ->
      cancelAnimation = $window.cancelAnimationFrame or getWithVendorPrefix('CancelAnimationFrame', $window) or getWithVendorPrefix('CancelRequestAnimationFrame', $window)
      if !cancelAnimation or iOS6($window)
        # iOS6 is buggy
        cancelAnimation = $timeout.cancel
      cancelAnimation
  ]
  return
do ->
  'use strict'
  # this is built upon http://stackoverflow.com/a/16136789/1004406
  snapscroll = angular.module('snapscroll')
  snapscroll.factory 'scroll', [
    '$q'
    'requestAnimation'
    'cancelAnimation'
    'defaultSnapscrollScrollEasing'
    ($q, requestAnimation, cancelAnimation, defaultSnapscrollScrollEasing) ->

      cleanUp = (element, animation) ->
        animation = null
        element.data 'snapscroll-animation', null
        element.data 'snapscroll-animation-deferred', null
        return

      {
        to: (element, top, duration, easing) ->
          start = undefined
          change = undefined
          animate = undefined
          deferred = undefined
          animation = undefined
          increment = undefined
          currentTime = undefined

          animate = ->
            currentTime += increment
            element[0].scrollTop = easing(currentTime, start, change, duration)
            if currentTime < duration
              animation = requestAnimation(animate, increment)
              element.data 'snapscroll-animation', animation
            else
              cleanUp element, animation
              deferred.resolve()
            return

          if !angular.isElement(element) or !angular.isNumber(top)
            return
          deferred = $q.defer()
          duration = parseInt(duration)
          animation = element.data('snapscroll-animation')
          if animation
            cancelAnimation animation
            # TODO: should the promise be rejected at this point since this is just cleaning up? 
            # element.data('snapscroll-animation-deferred').reject();
            cleanUp element, animation
          if duration == 0 or isNaN(duration)
            element[0].scrollTop = top
            deferred.resolve()
          else
            if typeof easing != 'function'
              easing = defaultSnapscrollScrollEasing
            start = element[0].scrollTop
            change = top - start
            currentTime = 0
            increment = 20
            animate()
          element.data 'snapscroll-animation-deferred', deferred
          deferred.promise
        stop: (element) ->
          animation = element.data('snapscroll-animation')
          if animation
            cancelAnimation animation
            element.data('snapscroll-animation-deferred').reject()
            cleanUp element, animation
          return

      }
  ]
  return

# ---
# generated by js2coffee 2.1.0
